/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipoPraticaStato } from './tipo-pratica-stato';


export interface BandoTransazioniSelectDTO { 
    id?: string;
    titolo?: string;
    codice?: string;
    nome_comune?: string;
    stato?: TipoPraticaStato;
    ultima_transazione?: string;
}



